export default __webpack_public_path__ + "static/media/visa.45c2726d.jpg";